import React, { useState, useEffect, useRef } from 'react'; 
import CheckToken from './CheckToken';
import Swal from 'sweetalert2';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Bell, PlusIcon } from 'lucide-react';
import NotificationCompo from './NotificationCompo';

import logo from "../asset/img/colorbg.png";

const Topbar = ({ onLocationSelect }) => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isNotifOpen, setIsNotifOpen] = useState(false);
  const navigate = useNavigate();
const location = useLocation();

  const profileRef = useRef(null);
  const notifRef = useRef(null);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) setIsProfileOpen(false);
      if (notifRef.current && !notifRef.current.contains(event.target)) setIsNotifOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


const userToken = localStorage.getItem('userToken');
const userName = localStorage.getItem('userName');
const userEmail = localStorage.getItem('userEmail');


const NEARMAP_API_KEY = 'NWI2ZWIzNTYtODdmMS00YmIyLTk5ZGItZDkwNTVjMDM2MzFi';
const MAPBOX_TOKEN = 'pk.eyJ1IjoibWVhc3JvYWRtaW5tYXBib3giLCJhIjoiY21wYzQybXVrMDN5NDJ1c2JkZGhmYWFsNiJ9.aI89Wt7FHAYw3FUonCbKkw';

const [searchQuery, setSearchQuery] = useState('');
const [suggestions, setSuggestions] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);
const debounceRef = useRef(null);




const handleSearchInput = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (value.trim().length < 3) {
        setSuggestions([]);
        setShowSuggestions(false);
        return;
    }

    debounceRef.current = setTimeout(async () => {
        try {
            const res = await fetch(
                `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(value)}.json?access_token=${MAPBOX_TOKEN}&autocomplete=true&limit=5`
            );
            const data = await res.json();
            setSuggestions(data.features || []);
            setShowSuggestions(true);
        } catch (err) {
            console.error("Mapbox geocoding error:", err);
        }
    }, 300);
};








const checkNearmapCoverage = async (lat, lng) => {
    try {
        const res = await fetch(
            `https://api.nearmap.com/coverage/v2/point/${lng},${lat}?apikey=${NEARMAP_API_KEY}&limit=5`
        );
        const data = await res.json();
        return data.surveys || [];
    } catch (err) {
        console.error("Nearmap coverage error:", err);
        return [];
    }
};




const handleSuggestionClick = async (feature) => {
    const [lng, lat] = feature.center;
    const name = feature.place_name;
    setSearchQuery(name);
    setShowSuggestions(false);
    setSuggestions([]);

    const surveys = await checkNearmapCoverage(lat, lng);
    if (surveys.length > 0) {
        console.log("Nearmap coverage found:", surveys);
        // most recent survey — pass its id if Home.js needs it for the Tile API
        onLocationSelect(lat, lng, name, surveys[0]?.id, surveys);
    } else {
        console.log("No Nearmap coverage at this location");
        onLocationSelect(lat, lng, name, null, []);
    }
};

 
// console.log("userName", userName);

const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You will need to login again to access your account!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33', // Matches btn-danger
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, logout!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        // 1. Remove the token
        localStorage.removeItem('userToken');
        
        // 2. Show success message (Optional but nice)
        Swal.fire({
          title: 'Logged Out!',
          text: 'You have been successfully logged out.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        });

        // 3. Redirect to login
        navigate('/login');
      }
    });
  };


  // search location code  
  // const autoCompleteRef = useRef();
  const inputRef = useRef();

// DELETE this whole block:
// useEffect(() => {
//     if (!window.google || !inputRef.current) return;

//     autoCompleteRef.current = new window.google.maps.places.Autocomplete(
//         inputRef.current,
//         { types: ['address'] }
//     );

//     autoCompleteRef.current.addListener("place_changed", () => {
//         const place = autoCompleteRef.current.getPlace();
//         if (place.geometry) {
//             const lat = place.geometry.location.lat();
//             const lng = place.geometry.location.lng();
//             const name = place.formatted_address;
//             onLocationSelect(lat, lng, name);
//         }
//     });
// }, []);


  return (
    <header className="top-navbar d-flex align-items-center justify-content-between px-3">
      {/* Left Section: Logo */}
      <div className="d-flex flex-column justify-content-center">
        <a href="/" className='d-flex flex-column justify-content-center text-white links'>
           <div className="d-flex align-items-center">
          
            <img src={logo} className='img-fluid' style={{maxHeight:"40px",}} />
        </div>
        <div className="sub-brand  text-white">Project Management Dashboard</div>
        </a>
       
      </div>

      {/* Center Section: Search Bar */}
      {/* <div className="search-wrapper flex-grow-1 mx-4">
        <div className="search-inner d-flex align-items-center px-3">
          <i className="fa-solid fa-magnifying-glass text-white-50 me-2"></i>
          <input 
            ref={inputRef} // Attached Ref
            type="text" 
            className="search-input" 
            placeholder="Search address or parcel..." 
          />
        </div>
      </div> */}


      {location.pathname === '/' && (
  <div className="search-wrapper flex-grow-1 mx-4" style={{ position: 'relative' }}>
    <div className="search-inner d-flex align-items-center px-3">
      <i className="fa-solid fa-magnifying-glass text-white-50 me-2"></i>
      <input 
        ref={inputRef} 
        type="text" 
        className="search-input" 
        placeholder="Search address or parcel..." 
        value={searchQuery}
        onChange={handleSearchInput}
        onFocus={() => suggestions.length > 0 && setShowSuggestions(true)}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
      />
    </div>

    {showSuggestions && suggestions.length > 0 && (
     <ul style={{
    position: 'absolute', top: '100%', left: '50%', 
    transform: 'translateX(-50%)',
    width: '650px', maxWidth: '100%', boxSizing: 'border-box',
    background: '#fff', borderRadius: '8px', marginTop: '4px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)', listStyle: 'none',
    padding: '4px 0', zIndex: 2000, maxHeight: '250px', overflowY: 'auto'
}}>
        {suggestions.map((feature) => (
          <li 
            key={feature.id}
            onClick={() => handleSuggestionClick(feature)}
            style={{
                padding: '8px 14px', cursor: 'pointer', fontSize: '13px',
                color: '#333', borderBottom: '1px solid #f0f0f0'
            }}
            onMouseDown={(e) => e.preventDefault()}
          >
            {feature.place_name}
          </li>
        ))}
      </ul>
    )}
  </div>
)}


      {/* Right Section: Actions */}
      <div className="d-flex align-items-center gap-3">


{location.pathname === '/' ? (
  /* Show this empty placeholder if on the home page (/) */
  <div className="  px-3 d-flex align-items-center gap-2"></div>
) : (
  /* Show the Edit button on all other pages */
  <a href="/" className="btn btn-dark-action btn-sm px-2 d-flex align-items-center gap-2">
    <PlusIcon /> Add Project
  </a>
)}


 


<NotificationCompo />


        {/* --- Profile Dropdown --- */}
        <div className="dropdown" ref={profileRef}>
          <div className="profile-pill d-flex align-items-center gap-2" onClick={() => setIsProfileOpen(!isProfileOpen)}>
            <div className="avatar-circle">{userName ? userName.charAt(0).toUpperCase() : '?' }</div>
            {/* <span className="profile-name d-none d-md-block">Sam Smith</span> */}
            <span class="d-md-block d-none profile-name text-nowrap">{userName}</span>
            <i className={`fa-solid fa-chevron-down ms-1 small transition-icon ${isProfileOpen ? 'rotate-180' : ''}`}></i>
          </div>

          <ul className={`dropdown-menu dropdown-menu-end profile-dropdown shadow-lg border-0 mt-2 ${isProfileOpen ? 'show' : ''}`} 
              style={{ display: isProfileOpen ? 'block' : 'none', position: 'absolute', right: 0 }}>
            <li className="px-3 py-2 border-bottom mb-2">
              <div className="d-flex align-items-center gap-2">
               <div className="avatar-circle-sm">
  {userName ? userName.charAt(0).toUpperCase() : '?' }
</div>
                <div>
                  <div className="fw-bold small text-dark">{userName}</div>
                  <div className="text-muted" style={{ fontSize: '11px' }}>{userEmail}</div>
                </div>
              </div>
            </li>
            <li><Link className="dropdown-item" to="/profile"><i className="fa-regular fa-user me-2"></i> My Profile</Link></li>
            <li><Link className="dropdown-item" to="/measurement"><i className="fa-solid fa-gear me-2"></i> Account Settings</Link></li>
            <li><Link className="dropdown-item" to="/notification-list"><Bell className="text-dark me-2" size={20} />Notifications</Link></li>
            <li className="mt-2 px-3 pb-2">
      <button 
        className="btn btn-danger w-100 btn-logout py-2" 
        onClick={handleLogout}
      >
        <i className="fa-solid fa-right-from-bracket me-2"></i> Logout
      </button>
    </li>
          </ul>
        </div>
      </div>
      <CheckToken />
    </header>
  );
};

export default Topbar;